import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import SORT_ORDER from '@tekion/tekion-base/constants/sortOrder';
import PropertyControlledComponent from '../../../../molecules/PropertyControlledComponent';
import FORM_ACTION_TYPES from '../../../FormBuilder/constants/actionTypes';
import { FIELD_IDS } from '../../multiSort.constants';
import SortOrderOption from './SortOrderOption';
import styles from './sortOrder.module.scss';
var SortOrder = function SortOrder(props) {
  var onAction = props.onAction,
    nestingPath = props.nestingPath;
  var sortOrder = _get(props, "original.".concat(FIELD_IDS.SORT_ORDER));
  var sortField = _get(props, "original.".concat(FIELD_IDS.SORT_FIELD));
  var onClickHandler = defaultMemoize(function (type) {
    return function () {
      onAction({
        type: FORM_ACTION_TYPES.ON_FIELD_CHANGE,
        payload: {
          id: FIELD_IDS.SORT_ORDER,
          nestingPath: nestingPath,
          params: {
            value: type
          }
        }
      });
    };
  });
  return /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: !_isEmpty(sortField)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sortOrderContainer
  }, /*#__PURE__*/React.createElement(SortOrderOption, {
    label: __('Ascending'),
    onClick: onClickHandler(SORT_ORDER.ASC),
    iconClassName: "icon-arrow-up",
    className: cx('flex-1', styles.leftButton, sortOrder === SORT_ORDER.ASC ? styles.leftButtonActive : styles.leftButtonInActive)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.separator
  }), /*#__PURE__*/React.createElement(SortOrderOption, {
    label: __('Descending'),
    onClick: onClickHandler(SORT_ORDER.DESC),
    iconClassName: "icon-arrow-down",
    className: cx('flex-1', styles.rightButton, sortOrder === SORT_ORDER.DESC ? styles.rightButtonActive : styles.rightButtonInActive)
  })));
};
SortOrder.defaultProps = {
  onAction: _noop,
  nestingPath: EMPTY_ARRAY
};
SortOrder.propTypes = {
  onAction: PropTypes.func,
  nestingPath: PropTypes.array
};
export default SortOrder;